import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string'
import { LOAD_DRIVER_ACTIVITY, GET_DRIVER_ACTIVITY, CLEAR_DRIVER_ACTIVITY } from "../types";
import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { DRIVER_ACTIVITY_ENDPOINT } from '../../config/endpoints';

const loadDriverActivity = (
  status
) => (dispatch) =>
    dispatch({
      type: LOAD_DRIVER_ACTIVITY,
      payload: status,
    });

const getDriverActivity = ({ driverId, fromDateString, toDateString }) => async (dispatch) => {
  try {
    dispatch(loadDriverActivity(true));
    const url = `${DRIVER_ACTIVITY_ENDPOINT}/driver?${QueryString.stringify({ driverId, fromDateString, toDateString })}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const activity = await response.json();
    dispatch({
      type: GET_DRIVER_ACTIVITY,
      payload: activity,
    });
  }
  catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(loadDriverActivity(false));
  }
};

const clearDriverActivity = () => (dispatch) =>
  dispatch({
    type: CLEAR_DRIVER_ACTIVITY,
  });

const exportFile = async (formValues) => async (dispatch) => {
  try {
    dispatch(loadDriverActivity(true));
    const url = `${DRIVER_ACTIVITY_ENDPOINT}/export?${QueryString.stringify(
      formValues,
    )}`;
    const response = await fetch(url, {
      ...DEFAULT_GET_CONFIG,
    });
    await isErrorResponse(response, null, dispatch);
    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'Tareo.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(loadDriverActivity(false));
  }
};

const getMonthlyDriverActivity = ({ fromDateString, toDateString, driverStatusTypes, homeBaseLocationIds }) => async (dispatch) => {
  try {
    dispatch(loadDriverActivity(true));
    const url = `${DRIVER_ACTIVITY_ENDPOINT}?${QueryString.stringify({ fromDateString, toDateString, driverStatusTypes, homeBaseLocationIds })}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const activity = await response.json();
    dispatch({
      type: GET_DRIVER_ACTIVITY,
      payload: activity,
    });
  }
  catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(loadDriverActivity(false));
  }
}

export {
  getDriverActivity,
  clearDriverActivity,
  exportFile,
  getMonthlyDriverActivity,
}